module.exports = __webpack_public_path__ + "img/128ne.8ba18865.svg";